export const permitConstants = {
  PERMANENT_PASS: 1, // Постоянный
  TEMPORARY_PASS: 2, // Временный
  ONE_TIME_PASS: 3, // Разовый
};
